import { Auth } from '@aws-amplify/auth';
import { useLocation, useNavigate } from 'react-router-dom';

import { getAuthPageUrl } from '../helpers/functions/url';
import rootStore from '../../rootStore/RootStore';

export default function useSignOut() {
  const location = useLocation();
  const navigate = useNavigate();

  const signOut = async () => {
    await Auth.signOut();
    rootStore.reset();
    void navigate(
      getAuthPageUrl({
        redirectedFrom: location.pathname + location.search,
      }),
      { replace: true },
    );
  };

  return { signOut };
}
